export default date => {
  if (date.length < 4) {
    return { showError: true, errorMsg: undefined };
  }
  const month = parseInt(date.slice(0, 2), 10);
  const year = parseInt(`20${date.slice(5)}`, 10);

  if (month > 12 || month < 1) {
    return { showError: true, errorMsg: "Invalid month" };
  }

  const now = new Date();
  const minDate = new Date(now.getFullYear(), now.getMonth(), 1);
  const expDate = new Date(year, month - 1);
  if (expDate.getTime() < minDate.getTime()) {
    return { showError: true, errorMsg: "Date is in the past" };
  }
  return { showError: false, errorMsg: undefined };
};
